import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Smile, Zap, Image as ImageIcon, Martini, Users, HeartHandshake } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function WhyMobileBartender() {
  const {
    t
  } = useLanguage();
  const benefits = [{
    icon: <Smile className="w-8 h-8" data-id="element-164" />,
    title: t('why.b1.title'),
    desc: t('why.b1.desc')
  }, {
    icon: <Zap className="w-8 h-8" data-id="element-165" />,
    title: t('why.b2.title'),
    desc: t('why.b2.desc')
  }, {
    icon: <ImageIcon className="w-8 h-8" data-id="element-166" />,
    title: t('why.b3.title'),
    desc: t('why.b3.desc')
  }, {
    icon: <Martini className="w-8 h-8" data-id="element-167" />,
    title: t('why.b4.title'),
    desc: t('why.b4.desc')
  }, {
    icon: <Users className="w-8 h-8" data-id="element-168" />,
    title: t('why.b5.title'),
    desc: t('why.b5.desc')
  }, {
    icon: <HeartHandshake className="w-8 h-8" data-id="element-169" />,
    title: t('why.b6.title'),
    desc: t('why.b6.desc')
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 md:py-32 bg-[#FFF8F0]" data-id="element-170">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-171">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-172">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif text-zinc-900 mb-6" data-id="element-173">
            {t('why.title.part1')} <br className="hidden md:block" data-id="element-174" />
            <span className="text-[#D4A843] italic" data-id="element-175">
              {t('why.title.part2')}
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-zinc-600 text-lg font-light" data-id="element-176">
            {t('why.subtitle')}
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-177">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white border border-amber-200/60 p-8 hover:border-[#D4A843]/50 shadow-sm hover:shadow-md transition-all duration-300 group" data-id="element-178">
              <div className="text-[#0D9488] mb-6 opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 transform origin-left" data-id="element-179">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-serif text-zinc-900 mb-3" data-id="element-180">
                {benefit.title}
              </h3>
              <p className="text-zinc-600 font-light leading-relaxed" data-id="element-181">
                {benefit.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}